
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const data = [
  { month: "January", value: 20 },
  { month: "February", value: 8 },
  { month: "March", value: 4 },
  { month: "April", value: 12 },
  { month: "May", value: 5 },
  { month: "June", value: 10 }
];

const CustomBarChart = () => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="value" fill="rgba(255, 99, 132, 0.5)" stroke="black" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
